"use client";

import { c as _c } from "react/compiler-runtime";
import { useElementOnScreen } from "@/hooks/useElementOnScreen";
import { useParallax } from "@/hooks/useParallax";
import { clsx } from "clsx";
import { ArrowRight } from "lucide-react";
import { useTranslations } from "next-intl";
import NextImage from "next/image";
export function ParallaxSection() {
  const $ = _c(38);
  const {
    ref,
    offsetY
  } = useParallax(0.3);
  const {
    containerRef,
    isVisible
  } = useElementOnScreen();
  const t = useTranslations("parallax");
  let t0;
  if ($[0] !== containerRef || $[1] !== ref) {
    t0 = el => {
      ref.current = el;
      containerRef.current = el;
    };
    $[0] = containerRef;
    $[1] = ref;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = `translateY(${offsetY}px)`;
  let t2;
  if ($[3] !== t1) {
    t2 = {
      transform: t1,
      top: "-15%"
    };
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <NextImage src="/images/portfolio/architecture-exterior.jpg" alt={"Architecture moderne - B\xE2timent contemporain"} fill={true} loading="lazy" className="object-cover object-bottom scale-[1.15]" sizes="100vw" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = <div className="absolute inset-0 w-full h-[130%]" style={t2}>{t3}</div>;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="absolute inset-0 bg-gradient-to-r from-charcoal/70 via-charcoal/40 to-transparent" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = isVisible && "visible";
  let t7;
  if ($[9] !== t6) {
    t7 = clsx("fade-in-left max-w-xl", t6);
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t) {
    t8 = t("tagline");
    $[11] = t;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t8) {
    t9 = <p className="text-terracotta-light font-medium mb-4 tracking-wider uppercase text-sm">{t8}</p>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t) {
    t10 = t("title");
    $[15] = t;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10) {
    t11 = <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-white-cream leading-tight mb-6">{t10}</h2>;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t) {
    t12 = t("description");
    $[19] = t;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12) {
    t13 = <p className="text-white-cream/80 text-lg mb-8">{t12}</p>;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t) {
    t14 = t("cta");
    $[23] = t;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <ArrowRight className="w-5 h-5" />;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t14) {
    t16 = <a href="#contact" className="btn-primary inline-flex items-center gap-2">{t14}{t15}</a>;
    $[26] = t14;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t11 || $[29] !== t13 || $[30] !== t16 || $[31] !== t7 || $[32] !== t9) {
    t17 = <div className="relative z-10 h-full flex items-center"><div className="max-w-7xl mx-auto px-6 w-full"><div className={t7}>{t9}{t11}{t13}{t16}</div></div></div>;
    $[28] = t11;
    $[29] = t13;
    $[30] = t16;
    $[31] = t7;
    $[32] = t9;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t0 || $[35] !== t17 || $[36] !== t4) {
    t18 = <section ref={t0} className="relative h-[60vh] md:h-[70vh] overflow-hidden">{t4}{t5}{t17}</section>;
    $[34] = t0;
    $[35] = t17;
    $[36] = t4;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  return t18;
}